/*
  Makes the review count beside the star rating scroll down to the Judge.me
  review widget.

  A plain anchor does nothing on a second click, because the hash is already
  set, so the scroll is driven directly. The target is looked up on click
  rather than up front, since Judge.me renders its widget after this runs.
*/
(function () {
  var link = document.querySelector('.ee-rating-link');
  if (!link) return;

  link.addEventListener('click', function (event) {
    var target = document.getElementById('judgeme_product_reviews');
    if (!target) return;

    event.preventDefault();
    history.replaceState(null, '', '#judgeme_product_reviews');
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // The widget can still be filling in, which moves where it lands.
    if (typeof ResizeObserver !== 'function') return;
    var observer = new ResizeObserver(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    observer.observe(target);
    setTimeout(function () {
      observer.disconnect();
    }, 1500);
  });
})();
